import PropTypes from "prop-types";
import WorkspaceSidebar from "../components/layout/sidebar/WorkspaceSidebar";
import AdminSidebar from "../components/layout/sidebar/AdminSidebar";
import ProjectSidebar from "../components/layout/sidebar/ProjectSidebar";

function getSidebar(name) {
    switch (name) {
        case "workspace":
            return <WorkspaceSidebar />;
        case "admin":
            return <AdminSidebar />;
        case "project":
            return <ProjectSidebar />;
        default:
            return <div>ERROR</div>;
    }
}

function useInjectSidebar({ sidebarName }) {
    const sidebar = getSidebar(sidebarName);
    return (Layout) => <Layout sidebar={sidebar} />;
}

useInjectSidebar.propTypes = {
    sidebarName: PropTypes.string,
};

export default useInjectSidebar;
